import React, { useMemo, useRef } from 'react';
import QuillEditor from './QuillEditor';

const NotesTextEditor = ({ value, onTextChange, styles = {}, className, placeholder = '', onBlur = () => {} }) => {
  const quillRef = useRef();

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, false] }],
          ['bold', 'italic', 'underline'],
          [{ align: [] }],
          [{ list: 'ordered' }],
          ['link'],
        ],
      },
    }),
    []
  );

  const mergedStyles = {
    ...styles,
    '& .ql-editor': {
      fontSize: '16px',
      ...styles?.['& .ql-editor'],
    },
  };

  return (
    <QuillEditor
      value={value}
      onTextChange={onTextChange}
      onBlur={onBlur}
      modules={modules}
      styles={mergedStyles}
      ref={quillRef}
      className={className}
      placeholder={placeholder}
    />
  );
};

export default NotesTextEditor;
